import { CallOutlined, MoveToInboxOutlined } from "@mui/icons-material";
import React from "react";

export default function CommLogHeader({ icon, title }) {
  const getIcon = (iconName) => {
    switch (iconName) {
      case "phone":
        return <CallOutlined />;
      case "sms":
        return <MoveToInboxOutlined />;
      default:
        return <CallOutlined />;
    }
  };
  return (
    <div className="border-1 mx-3 flex flex-row-reverse justify-between border-b border-black px-3 pt-4">
      <div className="mx-auto my-2 w-[50%] text-right"></div>

      <div className="w-[50%] self-end rounded-t-md">
        <h2 className="flex w-full flex-row items-center py-1 text-center text-lg">
          <div className="mb-1 mr-1 block">{getIcon(icon)}</div>
          <span className="block">{title}</span>
        </h2>
      </div>
    </div>
  );
}
